export default __webpack_public_path__ + "media/images/features/local_delivery/top-e71978b38148cccbf3cf14766a67b8f6.png";